import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';

const CCTVPlayer = ({ url }) => {
  const videoRef = useRef();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        setLoading(false);
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS error:", data);
        setError(true);
      });

      return () => hls.destroy();
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.current.src = url;
      videoRef.current.onloadeddata = () => setLoading(false);
      videoRef.current.onerror = () => setError(true);
    }
  }, [url]);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          เชื่อมต่อไม่สำเร็จ..
        </div>
        <div style={{ fontSize: '1rem' }}>
          ระบบปิดทำงานช่วงสงคราม โปรดรอการกลับมา..
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100vw', height: '100vh', position: 'relative' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%', height: '100%',
          backgroundImage: 'url("/621.jpg")', // ใช้ภาพจาก public folder
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          fontSize: '1.5rem',
          transition: 'opacity 0.5s ease',
          zIndex: 2
        }}>
          กำลังโหลดสตรีม...
        </div>
      )}
      <video
        ref={videoRef}
        controls
        autoPlay
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </div>
  );
};

export default CCTVPlayer;
